import { render, staticRenderFns } from "./ListDefault.vue?vue&type=template&id=a27c637c"
import script from "./ListDefault.vue?vue&type=script&lang=js"
export * from "./ListDefault.vue?vue&type=script&lang=js"
import style0 from "./ListDefault.vue?vue&type=style&index=0&id=a27c637c&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports